import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';

import { Doctor, LoginResponse } from '@app/shared-module/models';
import { Constants } from '@app/shared-module/constants';
import { CommonService } from '@app/shared-module/common-service.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

  constructor(
    private http: HttpClient,
    private commService: CommonService,
    private router: Router) { }

  login(username: string, password: string) {
    return this.http.post<any>(Constants.MAIN_ENV_URL + Constants.INTERNAL_LOGIN_API, { username, password }, { withCredentials: true })
      .pipe(map((data: LoginResponse) => {
        // store user details and basic auth credentials in local storage to keep user logged in between page refreshes
        if (data && data.http_code === Constants.STATUS_200 && data.result.internalUser && data.result.token) {
          localStorage.setItem('internallogin', JSON.stringify(data.result.internalUser));
          localStorage.setItem('token', JSON.stringify(data.result.token));
          this.commService.setInternalLoginValue(data.result.internalUser);
          this.commService.setTokenValue(data.result.token);
          return data.result.internalUser;
        } else {
          return this.router.parseUrl('login');
        }
      }));
  }

  logout() {
    localStorage.removeItem('internallogin');
    localStorage.removeItem('token');
    this.commService.setInternalLoginValue(null);
    this.commService.setTokenValue(null);
  }
}
